import styled from "styled-components";
import Card from "../card";

const Styled = styled(Card)`
  .ant-flex {
    user-select: none;
    cursor: pointer;
  }
  .content {
    overflow: hidden;
    padding-top: 2.4rem;
    display: ${(_) => (_.active ? "block" : "none")};
  }
  .icon {
    transform: ${(_) => `rotate(${_.active ? 0 : -90}deg)`};
    transition: 0.3s ease;
  }
`;

export default Styled;
